import { jsxs as j, jsx as d } from "react/jsx-runtime";
import { forwardRef as R, useMemo as D } from "react";
import { e as K } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as T } from "./tw-cn-mXgPecoF.mjs";
import { c as n } from "./index-BpNK5r1N.mjs";
const $ = n(
  [
    "border-1 border-transparent shrink-0 overflow-hidden inline-flex justify-center items-center rounded-capsule cursor-pointer select-none border-box"
  ],
  {
    variants: {
      theme: {
        filled: "bg-fill-neutral-weak hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
        outlined: "border border-line-neutral-weak3 bg-static-white hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1"
      },
      size: {
        large: "h-42 px-16 typography-subtitle-16-regular",
        medium: "h-36 px-12 typography-body-14-regular"
      },
      pcSize: {
        large: "pc:h-42 pc:px-16 pc:typography-subtitle-16-regular",
        medium: "pc:h-36 pc:px-12 pc:typography-body-14-regular"
      },
      selected: {
        false: "",
        true: "font-bold text-text-primary-main hover-never:bg-none active:bg-none"
      },
      weight: {
        regular: "",
        bold: "!font-bold"
      },
      disabled: {
        false: "",
        true: "cursor-not-allowed hover-never:bg-none active:bg-none"
      },
      disabledType: {
        default: "",
        strikethrough: "line-through"
      }
    },
    compoundVariants: [
      {
        theme: "filled",
        selected: !0,
        className: [
          "border border-line-primary-main !font-bold bg-fill-primary-weak",
          "hover-never:bg-interaction-primary-presshover-weak1 active:bg-interaction-primary-presshover-weak1"
        ]
      },
      {
        theme: "outlined",
        selected: !0,
        className: [
          "border border-line-primary-main !font-bold bg-fill-primary-weak",
          "hover-never:bg-interaction-primary-presshover-weak1 active:bg-interaction-primary-presshover-weak1 "
        ]
      },
      {
        theme: "filled",
        selected: !1,
        disabled: !0,
        className: [
          "bg-fill-neutral-weak text-interaction-neutral-disable-main",
          "hover-never:bg-fill-neutral-weak active:bg-fill-neutral-weak"
        ]
      },
      {
        theme: "filled",
        selected: !0,
        disabled: !0,
        className: [
          "bg-fill-neutral-weak border-interaction-neutral-disable-main text-interaction-neutral-disable-main",
          "hover-never:bg-fill-neutral-weak active:bg-fill-neutral-weak"
        ]
      },
      {
        theme: "outlined",
        selected: !1,
        disabled: !0,
        className: [
          "bg-fill-neutral-weak border-interaction-neutral-disable-main text-interaction-neutral-disable-main",
          "hover-never:bg-fill-neutral-weak active:bg-fill-neutral-weak"
        ]
      },
      {
        theme: "outlined",
        selected: !0,
        disabled: !0,
        className: [
          "bg-fill-neutral-weak border-interaction-neutral-disable-main text-interaction-neutral-disable-main",
          "hover-never:bg-fill-neutral-weak active:bg-fill-neutral-weak"
        ]
      },
      {
        disabled: !0,
        disabledType: "strikethrough",
        className: "line-through"
      }
    ],
    defaultVariants: {
      weight: "regular",
      theme: "filled",
      disabledType: "default"
    }
  }
), L = n("flex items-center mr-2 ", {
  variants: {
    size: {
      large: "h-42 pl-16 [&>svg]:size-18",
      medium: "h-36 pl-12 [&>svg]:size-15"
    },
    pcSize: {
      large: "h-42 pc:pl-16 pc:[&>svg]:size-18",
      medium: "h-36 pc:pl-12 pc:[&>svg]:size-15"
    },
    disabled: {
      false: "",
      true: "cursor-not-allowed"
    }
  }
}), M = n("flex items-center ml-2", {
  variants: {
    size: {
      large: "h-42 pr-16 [&>svg]:size-18",
      medium: "h-36 pr-12 [&>svg]:size-15"
    },
    pcSize: {
      large: "h-42 pc:pr-16 pc:[&>svg]:size-18",
      medium: "h-36 pc:pr-12 pc:[&>svg]:size-15"
    },
    disabled: {
      false: "",
      true: "cursor-not-allowed"
    }
  }
}), O = R(
  ({
    theme: m = "filled",
    size: u,
    selected: h = !1,
    weight: v = "regular",
    iconVisualCorrectionSpacing: e,
    leftIcon: a,
    rightIcon: l,
    className: f,
    children: c,
    onClick: s,
    onRightIconClick: p,
    onLeftIconClick: b,
    disabled: g = !1,
    disabledType: o = "default"
  }, w) => {
    const r = g || o === "strikethrough", i = K({
      property: u,
      mobileKey: "size",
      pcKey: "pcSize",
      defaultValue: {
        mobile: "medium",
        pc: "large"
      }
    }), y = $({ theme: m, weight: v, selected: h, disabled: r, disabledType: o, ...i }), k = L({
      disabled: r,
      ...i
    }), x = M({
      disabled: r,
      ...i
    }), z = D(() => {
      const t = a || l ? 2 : 0, N = (e == null ? void 0 : e.mobile) ?? t, P = (e == null ? void 0 : e.pc) ?? t;
      return `mx-${N} pc:mx-${P}`;
    }, [e == null ? void 0 : e.mobile, e == null ? void 0 : e.pc, a, l]);
    return /* @__PURE__ */ j(
      "button",
      {
        className: T(y, { "pr-0 pc:pr-0": !!l, "pl-0 pc:pl-0": !!a }, f),
        disabled: r,
        onClick: (t) => {
          r || (t.stopPropagation(), s == null || s());
        },
        ref: w,
        tabIndex: 0,
        type: "button",
        children: [
          !!a && /* @__PURE__ */ d(
            "div",
            {
              className: k,
              onClick: (t) => {
                !b || r || (t.stopPropagation(), b());
              },
              role: "button",
              tabIndex: r ? -1 : 0,
              children: a
            }
          ),
          /* @__PURE__ */ d("span", { className: z, children: c }),
          !!l && /* @__PURE__ */ d(
            "div",
            {
              className: x,
              onClick: (t) => {
                !p || r || (t.stopPropagation(), p());
              },
              role: "button",
              tabIndex: r ? -1 : 0,
              children: l
            }
          )
        ]
      }
    );
  }
);
O.displayName = "NDS.Chip";
export {
  O as C
};
